module.exports = __webpack_public_path__ + "resource/img/image049Dark.2c38b689.png";